import { render } from "./EnbBag02.vue?vue&type=template&id=5cbbaca5&scoped=true"
import script from "./EnbBag02.vue?vue&type=script&lang=js"
export * from "./EnbBag02.vue?vue&type=script&lang=js"

import "./EnbBag02.vue?vue&type=style&index=0&id=5cbbaca5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbbaca5"]])

export default __exports__